module.exports = __webpack_public_path__ + "static/media/astro_yay.4d60f5a6.png";